import React from "react";

export default function ChevronIcon({ direction = "down", color = "#e10092", size = 30 }) {
  const rotate = {
    down: "rotate(0deg)",
    up: "rotate(180deg)",
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      style={{ transform: rotate[direction], transition: "transform 0.3s ease" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
    </svg>
  );
}
